import styled from 'styled-components';

import { c00EE91, cFF005C } from '#/colors';

const ValueChange = styled.span<{
  direction: 'up' | 'down' | null;
}>`
  ${({ direction }) =>
    direction && `color: ${direction === 'up' ? c00EE91 : cFF005C}`};
`;

export default ValueChange;
